import React from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
};

export const ProductDashboard: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div className="mt-20 mb-60 py-16 lg:py-4">
        <div className="relative max-w-xl max-w-7xl">
          <div className="relative mt-8 lg:mt-12 lg:grid lg:grid-cols-2 lg:items-center">
            <div className="relative xl:mr-0 lg:mr-10">
              <div className="max-w-3xl  text-left">
                <h2 className="mt-10 text-base text-primary-600 font-semibold tracking-wide uppercase">
                  Dashboard
                </h2>
                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  One screen to manage everything.
                </p>
                <div className="text-xl text-gray-700 sm:text-xl mt-4 xl:mt-6">
                  <p>
                    Our dashboard brings everything together to power your
                    operation.
                  </p>
                </div>
              </div>
              <dl className="mt-10 space-y-10">
                <div className="flex">
                  <div className="">
                    <dt className="text-lg leading-6 font-medium text-gray-900">
                      Menu Management
                    </dt>
                    <dd className="mt-2 text-base text-gray-500">
                      We combine intuitive design and simple logic with features
                      specific to a digital menu. Easily import pictures,
                      control multiple menus, take items offline, assign
                      modifiers, make changes that reflect instantly for the
                      guest, and so much more.
                    </dd>
                  </div>
                </div>
                <div className="flex">
                  <div className="">
                    <dt className="text-lg leading-6 font-medium text-gray-900">
                      QR Code Library
                    </dt>
                    <dd className="mt-2 text-base text-gray-500">
                      Automatically generate, assign, download, and print QR
                      codes directly from your TableTab account. Guests who scan
                      our QR codes will go directly to your digital menu without
                      having to create an account or download an app.
                    </dd>
                  </div>
                </div>
                <div className="flex">
                  <div className="">
                    <dt className="text-lg leading-6 font-medium text-gray-900">
                      Device Management
                    </dt>
                    <dd className="mt-2 text-base text-gray-500">
                      Control how you recieve and direct TableTab orders.
                      TableTab orders are recieved via pre-existing tablet(s)
                      and can be optionally sent to your printers. Printing
                      orders can be done automatically or upon accepting an
                      order on a tablet.
                    </dd>
                  </div>
                </div>
                <div className="flex">
                  <div className="">
                    <dt className="text-lg leading-6 font-medium text-gray-900">
                      Direct Support Channels
                    </dt>
                    <dd className="mt-2 text-base text-gray-500">
                      Access our knowledge base for frequently asked questions
                      or reach out via your personal chatbot as another channel
                      to connect with our team directly. Because our technology
                      is fully built in-house, all support requests are resolved
                      quickly.
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div
              className="transform scale-100 xl:scale-125 mt-10 relative lg:mt-0 xl:-mr-60 2xl:-mr-96 xl:ml-14 2xl:ml-40 lg:-mr-40"
              aria-hidden="true"
            >
              <div className="relative py-3 w-full mx-auto">
                {/*<div className="absolute px-4 py-10 bg-white shadow-lg rounded-2xl sm:rounded-3xl sm:p-20 bg-primary-600" />*/}
                <div
                  className={
                    ' relative  bg-white shadow-2xl rounded-lg w-full lg:w-full md:w-4/5 xl:w-4/5 mx-auto '
                  }
                >
                  <picture className="lazyload">
                    <source
                      srcSet={getImageSrc('home_dashboard.webp')}
                      type="image/webp"
                    />
                    <source
                      srcSet={getImageSrc('home_dashboard.jpg')}
                      type="image/jpeg"
                    />
                    <img
                      src={getImageSrc('home_dashboard.webp')}
                      alt={'qr codes'}
                      className={'rounded-lg'}
                    />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDashboard;
